import React from "react";
import style from "./style.scss";

export const ButtonRow = ({ children }) => {
    return <div className={style.base}>{children}</div>;
};
